import { render, staticRenderFns } from "./new.page.vue?vue&type=template&id=42c4517c&scoped=true&"
import script from "./new.page.vue?vue&type=script&lang=js&"
export * from "./new.page.vue?vue&type=script&lang=js&"
import style0 from "./new.page.vue?vue&type=style&index=0&id=42c4517c&lang=scss&scoped=true&"
import style1 from "./new.page.vue?vue&type=style&index=1&id=42c4517c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c4517c",
  null
  
)

export default component.exports